export default {
  "SetupCard": "_SetupCard_1n9tz_1",
  "SetupCardHeader": "_SetupCardHeader_1n9tz_29",
  "Status": "_Status_1n9tz_40",
  "SetupCardItems": "_SetupCardItems_1n9tz_71",
  "SetupCardItem": "_SetupCardItem_1n9tz_71",
  "WithIcon": "_WithIcon_1n9tz_91"
};import "ni:sha-256;8Pd0higzAegUShqII5312dVdtg3QD9dCM0wDZ3DmRhA";